import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ClubService } from "../../providers/club.service";

import { BvIconComponent } from "../../design-system/primitives/icon.component";
import { BvMenuTriggerForDirective, BvMenuComponent, BvMenuItemComponent } from "../../design-system/primitives/menu.component";
import { TranslateModule } from "@ngx-translate/core";
@Component({
    selector: "app-league-list",
    templateUrl: "./league-list.component.html",
    styleUrls: ["./league-list.component.scss"],
    imports: [BvIconComponent, BvMenuTriggerForDirective, BvMenuComponent, BvMenuItemComponent, TranslateModule]
})
export class LeagueListComponent implements OnInit {
  @Input() availLeagues!: any[];
  @Input() leaguesToAdd: any;
  @Input() leaguesToRemove: any;
  @Input() leagueList: any;
  @Input() manageRegistrations: boolean = true;
  // Split parents froze their league membership at split time (children carry
  // the league); the picker locks so it can't be re-attached and double-count.
  @Input() splitParent: boolean = false;
  // The maps above are mutated by reference (no change event), so hosts that
  // need to react to an attach — e.g. defaulting Track knockouts on for a
  // knockout-scoring league — listen here.
  @Output() leagueAdded = new EventEmitter<any>();
  addLeagueOpen: boolean = false;
  leagueSelect: number = 0;
  constructor(public clubServ: ClubService) {}

  ngOnInit() {}
  removeLeague(evt: any) {
    if (this.leaguesToAdd[evt.leagueID]) delete this.leaguesToAdd[evt.leagueID];
    else this.leaguesToRemove[evt.leagueID] = evt;
    this.availLeagues.push(evt);
    
    // Remove from leagueList array
    const index = this.leagueList.findIndex((league: any) => league.leagueID === evt.leagueID);
    if (index !== -1) {
      this.leagueList.splice(index, 1);
    }
  }
  addLeague() {
    const league = this.availLeagues[this.leagueSelect];
    this.leagueList.push(league);
    if (this.leaguesToRemove[league.leagueID])
      delete this.leaguesToRemove[league.leagueID];
    else this.leaguesToAdd[league.leagueID] = league;
    this.availLeagues.splice(this.leagueSelect, 1);
    this.leagueSelect = 0;
    this.leagueAdded.emit(league);
  }
}
